import { Td, Textarea, Th, Tr } from '@chakra-ui/react'
import styled from '@emotion/styled'
import { ComponentProps, forwardRef } from 'react'

export const MessageTimelineTableWrapper = styled.div`
    flex: 3 0 0%;
    width: 100%;
    padding: 0 var(--chakra-space-2);
`

export const TableScrollWrapper = styled.div`
    margin-top: var(--chakra-space-2);
    overflow-y: auto;
    max-height: 70vh;
    padding-left: 24px;
    margin-left: -24px;

    table {
        border-collapse: separate;
        border-spacing: 0;
    }

    thead {
        z-index: 3;
        position: sticky;
        top: 0;
    }
    thead tr th {
        background-color: var(--chakra-colors-background);
    }

    @media screen and (max-width: 1164px) {
        max-height: 40vh;
    }
`

export const MessageDetailsTableWrapper = styled.div`
    flex: 2 0 0%;
    width: 100%;
    padding: 0 var(--chakra-space-2);

    @media screen and (max-width: 730px) {
        overflow-x: auto;
    }
`

type MessageTimelineTableRowProps = {
    isSelected?: boolean
    isEven?: boolean
    ref?: any
} & ComponentProps<typeof Tr>

export const MessageTimelineTableRow = styled(
    forwardRef(({ isSelected, isEven, ...props }: MessageTimelineTableRowProps, ref) => <Tr ref={ref} {...props} />)
)`
    ${({ isSelected }) => (isSelected ? 'color: var(--chakra-colors-whiteAlpha-900);' : '')};
    background-color: ${({ isSelected, isEven }) => (isSelected ? 'var(--chakra-colors-selected-row-background)' : isEven ? 'var(--chakra-colors-background)' : 'var(--chakra-colors-odd-background)')};

    ${({ isAppeared }) => (isAppeared ? 'animation: opacityAnimation 1s ease-in;' : '')};
    ${({ isAppeared }) => (isAppeared ? 'animation-iteration-count: 1;' : '')};
    ${({ isAppeared }) => (isAppeared ? 'opacity: 0.5;' : '')};

    @keyframes opacityAnimation {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 0.5;
        }
    }

    & > td {
        border-bottom: none;

        &:first-of-type {
            border-radius: 2px 0 0 2px;
            padding-left: 8px;
        }
    }
`

type ParsedMessageBlockWrapperwProps = {
    isSearch?: boolean
} & React.HTMLAttributes<HTMLDivElement>

export const ParsedMessageBlockWrapper = styled(({ isSearch, ...props }: ParsedMessageBlockWrapperwProps) => (
    <div {...props}/>
))`
    padding: var(--chakra-space-2) var(--chakra-space-4);
    align-self: center;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: wrap;
    flex-shrink: 0;
    width: 100%;
    ${({ isSearch }) => (!isSearch ? 'padding: 0 20px;' : '')};
    ${({ isSearch }) => (!isSearch ? 'max-width: 1300px;' : '')};
    min-width: 300px;
    @media screen and (max-width: 1200px) {
        font-size: 10px !important;
    }

    @media screen and (max-width: 730px) {
        flex-direction: column;
    }
`

type MessageDetailTableRowProps = {
    isEven?: boolean
    isError?: boolean
    bgColor?: string
} & ComponentProps<typeof Tr>

export const MessageDetailTableRow = styled(({ isEven, isError, bgColor, ...props }: MessageDetailTableRowProps) => (
    <Tr {...props} />
))`
    background-color: ${({ isEven, isError, bgColor }) =>
        isError ? 'var(--chakra-colors-selected-row-background)' : bgColor || (isEven ? 'var(--chakra-colors-background)' : 'var(--chakra-colors-odd-background)')};

    & > td {
        border-bottom: none;

        &:first-of-type {
            padding-left: 8px;
        }
    }
`

export const CustomTr = styled(Tr)`
    & > th {
        text-align: left;
        text-transform: none;
        font-weight: 800;
        font-family: inherit;
    }
`

export const CustomTh = styled(Th)`
    padding-top: var(--chakra-space-3);
    padding-bottom: var(--chakra-space-3);
    font-size: inherit;
`

export const TimelineTr = styled(CustomTr)`
    & > th {
        padding-inline-start: 2px;
        padding-inline-end: 2px;
        &:first-of-type {
            border-radius: 2px 0 0 2px;
            padding-left: 8px;
        }
    }
`

export const LPTd = styled(Td)`
    padding-inline-start: 2px;
    padding-inline-end: 2px;
    font-size: 0.8rem;
`

export const MessageTextarea = styled(Textarea)`
    width: 100%;
    border-radius: 2px;
    font-family: Roboto Mono, serif;
    font-size: 12px;
    background: var(--chakra-colors-input);
`

export const ErrorMessage = styled.div`
    width: 100%;
    max-width: 1300px;
    min-width: 500px;
    padding-top: 20px;
    display: flex;
    text-align: left;
    font-size: 14px;
    flex-direction: column;
`

export const ButtonsBlock = styled.div`
  border-radius: 2px;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  width: 16px;
  position: absolute;
  left: -24px;
  top: 3px;
  flex-wrap: wrap;
  transform: translateY(-12px);

  @media not all and (min-resolution:.001dpcm) { @media {
    position: relative;
    left: -20px;
    top: 2px;
  }}
`